import { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";

interface sensorItem {
  onClose: () => void;
  resizeChart: number;
  chartTitle: string;
  selectTime: string;
}

const ExtremeHeavyRainfallChartOverlayer: React.FC<sensorItem> = ({
  onClose,
  resizeChart,
  chartTitle,
  selectTime,
}) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const [chartInstance, setChartInstance] = useState<echarts.ECharts>();

  const generateTimeData = (interval: number, points: number) => {
    const now = new Date();
    const data = [];
    for (let i = points; i >= 0; i--) {
      const time = new Date(now.getTime() - i * interval * 60 * 1000);
      if (i === 0) {
        data.push("Now");
      } else {
        const hours = time.getHours().toString().padStart(2, "0");
        const minutes = time.getMinutes().toString().padStart(2, "0");
        data.push(`${hours}:${minutes}`);
      }
    }

    return data;
  };

 
  const getTimeData = (selectTime: string) => {
    switch (selectTime) {
      case "thirtymin":
        return generateTimeData(30, 12);
      case "onehour":
        return generateTimeData(60, 12);
      case "twelvehours":
        return generateTimeData(60, 12 * 12);
      case "twenty4hours":
        return generateTimeData(60, 12 * 24);
      default:
        return generateTimeData(30, 12);
    }
  };

  useEffect(() => {
    let myChart: echarts.ECharts | null = null;

    if (chartRef.current && chartRef.current.clientWidth) {
      myChart = echarts.init(chartRef.current, "dark");

      const timeData = getTimeData(selectTime);

      const option: echarts.EChartsOption = {
        backgroundColor: {
          type: "radial",
          x: 0.3,
          y: 0.3,
          r: 0.8,
          colorStops: [
            { offset: 0, color: "#FFFFFF00" },
            { offset: 1, color: "#FFFFFF00" },
          ],
        },
        title: { text: chartTitle, left: "center" },
        grid: {
          left: 10,
          containLabel: true,
          bottom: 0,
          top: "20%",
          right: 30,
        },
        xAxis: {
        
          name: "Time",
          nameLocation: "middle",
          axisLabel: {
            color: "white",
          },
          data: timeData,
        },
        yAxis: {
          name: "mm",
          axisLabel: {
            color: "white",
          },
          scale: true,
        },
        series: [
          {
            data: [102, 104, 108, 115, 120, 123, 125, 128, 130, 133, 135, 138, 140],
            type: "line",
            showSymbol: false,
          },
        ],
      };

      if (myChart) {
        myChart.setOption(option);
        setChartInstance(myChart);
      }

      return () => {
        if (myChart) {
          myChart.dispose();
        }
      };
    }
  }, []);

  useEffect(() => {
    if (chartInstance) {
      const timeData = getTimeData(selectTime);
      chartInstance.setOption({
        xAxis: {
          data: timeData,
        },
      });
    }
  }, [selectTime, chartInstance]);

  useEffect(() => {
    if (resizeChart && chartInstance) {
      chartInstance.resize();
    }

  }, [resizeChart]);

  return <div ref={chartRef} style={{ width: "100%", height: "80%" }} />;
};

export default ExtremeHeavyRainfallChartOverlayer;
